import { render, staticRenderFns } from "./DeviceCrud.vue?vue&type=template&id=0bf362cc&scoped=true&"
import script from "./DeviceCrud.vue?vue&type=script&lang=js&"
export * from "./DeviceCrud.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCrud.vue?vue&type=style&index=0&id=0bf362cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf362cc",
  null
  
)

export default component.exports